// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Transit API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CanonicalRoutesRequest,
  CanonicalRoutesResponse,
  ErrorResponse,
  GetRoutesNearbyParams,
  NearbyRoute,
} from "../models";

import { customFetch } from ".././fetcher";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetRoutesNearbyUrl = (params: GetRoutesNearbyParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/routes/nearby?${stringifiedParams}`
    : `/api/routes/nearby`;
};

/**
 * @summary Get nearby transit routes with direction variants
 */
export const getRoutesNearby = async (
  params: GetRoutesNearbyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<NearbyRoute[]> => {
  return customFetch<NearbyRoute[]>(getGetRoutesNearbyUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRoutesNearbyQueryKey = (params?: GetRoutesNearbyParams) => {
  return [`/api/routes/nearby`, ...(params ? [params] : [])] as const;
};

export const getGetRoutesNearbyQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoutesNearby>>,
  TError = ErrorResponse,
>(
  params: GetRoutesNearbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoutesNearby>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRoutesNearbyQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoutesNearby>>> = ({
    signal,
  }) => getRoutesNearby(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoutesNearby>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoutesNearbyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoutesNearby>>
>;
export type GetRoutesNearbyQueryError = ErrorResponse;

export function useGetRoutesNearby<
  TData = Awaited<ReturnType<typeof getRoutesNearby>>,
  TError = ErrorResponse,
>(
  params: GetRoutesNearbyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoutesNearby>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoutesNearby>>,
          TError,
          Awaited<ReturnType<typeof getRoutesNearby>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoutesNearby<
  TData = Awaited<ReturnType<typeof getRoutesNearby>>,
  TError = ErrorResponse,
>(
  params: GetRoutesNearbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoutesNearby>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoutesNearby>>,
          TError,
          Awaited<ReturnType<typeof getRoutesNearby>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoutesNearby<
  TData = Awaited<ReturnType<typeof getRoutesNearby>>,
  TError = ErrorResponse,
>(
  params: GetRoutesNearbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoutesNearby>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get nearby transit routes with direction variants
 */

export function useGetRoutesNearby<
  TData = Awaited<ReturnType<typeof getRoutesNearby>>,
  TError = ErrorResponse,
>(
  params: GetRoutesNearbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoutesNearby>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoutesNearbyQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCanonicalizeRoutesUrl = () => {
  return `/api/routes/canonical`;
};

/**
 * Maps route ids a client stored earlier (e.g. a Favorite saved before a Shakeup) to the current `route_id`, resolved per the agency's declared route identity: a `lametro-bus` id such as `720-13196` resolves through its line to the current `720-13201`; a `lametro-rail` id is already canonical and returned unchanged. Items are echoed in request order. Failure is per item, never per batch: an unknown agency, or a line with no current route, yields `canonicalRouteId: null` for that item only. Not cached.
 * @summary Resolve stored route ids to their current Canonical Route Id
 */
export const canonicalizeRoutes = async (
  canonicalRoutesRequest: CanonicalRoutesRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CanonicalRoutesResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customFetch<CanonicalRoutesResponse>(getCanonicalizeRoutesUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(canonicalRoutesRequest),
  });
};

export const getCanonicalizeRoutesQueryKey = (
  canonicalRoutesRequest?: CanonicalRoutesRequest,
) => {
  return ["POST", `/api/routes/canonical`, canonicalRoutesRequest] as const;
};

export const getCanonicalizeRoutesQueryOptions = <
  TData = Awaited<ReturnType<typeof canonicalizeRoutes>>,
  TError = ErrorResponse,
>(
  canonicalRoutesRequest: CanonicalRoutesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof canonicalizeRoutes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCanonicalizeRoutesQueryKey(canonicalRoutesRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof canonicalizeRoutes>>
  > = ({ signal }) =>
    canonicalizeRoutes(canonicalRoutesRequest, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof canonicalizeRoutes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CanonicalizeRoutesQueryResult = NonNullable<
  Awaited<ReturnType<typeof canonicalizeRoutes>>
>;
export type CanonicalizeRoutesQueryError = ErrorResponse;

export function useCanonicalizeRoutes<
  TData = Awaited<ReturnType<typeof canonicalizeRoutes>>,
  TError = ErrorResponse,
>(
  canonicalRoutesRequest: CanonicalRoutesRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof canonicalizeRoutes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canonicalizeRoutes>>,
          TError,
          Awaited<ReturnType<typeof canonicalizeRoutes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCanonicalizeRoutes<
  TData = Awaited<ReturnType<typeof canonicalizeRoutes>>,
  TError = ErrorResponse,
>(
  canonicalRoutesRequest: CanonicalRoutesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof canonicalizeRoutes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canonicalizeRoutes>>,
          TError,
          Awaited<ReturnType<typeof canonicalizeRoutes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCanonicalizeRoutes<
  TData = Awaited<ReturnType<typeof canonicalizeRoutes>>,
  TError = ErrorResponse,
>(
  canonicalRoutesRequest: CanonicalRoutesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof canonicalizeRoutes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Resolve stored route ids to their current Canonical Route Id
 */

export function useCanonicalizeRoutes<
  TData = Awaited<ReturnType<typeof canonicalizeRoutes>>,
  TError = ErrorResponse,
>(
  canonicalRoutesRequest: CanonicalRoutesRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof canonicalizeRoutes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCanonicalizeRoutesQueryOptions(
    canonicalRoutesRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
